import {
  AssignBikerToOrderPayload,
  CreateCustomerPayload,
  CreateOfflineCustomerPayload,
  ExpressPlusEstimatePricePayload,
  IPaginationCustomer,
  IPaginationInput,
} from '../../models/payload/customer';
import { offlineRopoloRequest, ropoloRequest } from '../axios';

const getCustomers = async (params: IPaginationInput) =>
  (
    await ropoloRequest.identityCustomersList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getCustomerLastOrderInformation = async (id: string) =>
  (await ropoloRequest.identityCustomersInformationDetail(id)).data;

const searchCustomers = async ({ search, networkStatus }: { search: string; networkStatus: boolean }) =>
  (
    await (networkStatus
      ? ropoloRequest.identityCustomersSearchList({ search })
      : offlineRopoloRequest.identityCustomersSearchList({ search }))
  ).data;

const getCustomersReport = async (params: IPaginationCustomer) =>
  (await ropoloRequest.identityCustomersReportList({ ...params })).data;

const getCustomersReportExcelList = async (params: IPaginationCustomer) =>
  (await ropoloRequest.identityCustomersReportExcelList({ ...params })).data;

const getUserRoles = async (userId: string) => (await ropoloRequest.identityUsersRolesDetail(userId)).data;

const getUserRolesByVenderId = async (userId: string, vendorId: string) =>
  (
    await ropoloRequest.identityUsersUserrolesDetail(userId, {
      vendorId,
    })
  ).data;

const bikerList = async (params: IPaginationInput) => (await ropoloRequest.bikersList(params)).data;

const getUserFreeBikers = async () => (await ropoloRequest.bikersFreeBikersList()).data;

const getUserAllBikers = async () => (await ropoloRequest.bikersKeyValueList()).data;

const createCustomer = async (payload: CreateCustomerPayload) =>
  (await ropoloRequest.identityUsersAddstaffCreate(payload)).data;

const createOfflineCustomer = async ({
  payload,
  networkStatus,
}: {
  payload: CreateOfflineCustomerPayload;
  networkStatus: boolean;
}) =>
  (
    await (networkStatus
      ? ropoloRequest.identityCustomersCreate(payload)
      : offlineRopoloRequest.identityCustomersCreate(payload))
  ).data;

const removeCustomer = async (id: string) =>
  (
    await ropoloRequest.identityUsersRemovestaffDelete({
      id,
    })
  ).data;

const getCustomerAddressesBasedOnDeliveryZonesList = async (vendorId: string) =>
  (await ropoloRequest.v1CustomerAddressesBasedOnDeliveryZonesList({ VendorId: vendorId })).data;

const getCustomerAddressesPrice = async ({ addressId, vendorId }: { addressId: string; vendorId: string }) =>
  (await ropoloRequest.v1DeliveryPricesAddressVendorDetail(addressId, vendorId)).data;

const assignBikerToOrder = async (payload: AssignBikerToOrderPayload) =>
  (await ropoloRequest.v1DeliveryByProvidersCreate(payload)).data;

const expressPlusEstimatePrice = async (payload: ExpressPlusEstimatePricePayload) =>
  (await ropoloRequest.v1DeliveryByProvidersEstimatedPriceList(payload)).data;

export {
  assignBikerToOrder,
  bikerList,
  createCustomer,
  createOfflineCustomer,
  expressPlusEstimatePrice,
  getCustomerAddressesBasedOnDeliveryZonesList,
  getCustomerAddressesPrice,
  getCustomers,
  getCustomersReport,
  getCustomersReportExcelList,
  getUserAllBikers,
  getUserFreeBikers,
  getUserRoles,
  getUserRolesByVenderId,
  removeCustomer,
  searchCustomers,
  getCustomerLastOrderInformation,
};
